import React from "react";
import { useBookingAppointmentTypeStore } from "../../../hooks";
import { useAppointmentStore } from "../../../hooks/redux-hooks/appointment-store/appointment.store";
import { usePetStore } from "../../../hooks/redux-hooks/pet-store/pet-store.service";
import { useUrgentVisitStore } from "../../../hooks/redux-hooks/urgent-visit-store/urgent-visit.store";
import { useModal } from "../../../context/ModalContext";
import { CREATE_BOOKING_TYPE, MODALS } from "../../../config/params";
import { UrgentVisitStep } from "../../../state/urgent-visit";
import { getDateEpochInTimezone } from "../../../utils/unix-timestamp";
import { extractReasonsAndNotes } from "../../containers/AppointmentReviewContainer/AppointmentReviewContainer";
// eslint-disable-next-line max-len
import ConfirmUrgentVisitToggleContainer from "../../containers/ConfirmUrgentVisitToggleContainer/ConfirmUrgentVisitToggleContainer";


const RescheduleUrgentVisitModal = () => {
  const { setBookingAppointmentType } = useBookingAppointmentTypeStore();
  const { appointmentDetails, setAppointmentsForm } = useAppointmentStore();
  const { petList } = usePetStore();
  const {
    resetUrgentVisit, setSelectedPets: setUrgentSelectedPets,
    setStep: setUrgentStep, setRescheduleAppointmentId,
    setPetReasons, setPetNotes, setSelectedDate,
  } = useUrgentVisitStore();
  const { closeModal, openModal } = useModal();

  const handleConfirmUrgentVisit = () => {
    setBookingAppointmentType(CREATE_BOOKING_TYPE.URGENT_BOOKING);
    resetUrgentVisit();
    setAppointmentsForm(null);

    if (appointmentDetails) {
      setSelectedDate(getDateEpochInTimezone(
        appointmentDetails.start_at, appointmentDetails.location.timeZone,
      ));
      setRescheduleAppointmentId(appointmentDetails.id);

      const petToSelect = (petList || []).find((p) => p.id === appointmentDetails.pet.id);
      if (petToSelect) {
        setUrgentSelectedPets([petToSelect]);
        setUrgentStep(UrgentVisitStep.TIME_SELECTION);
        if (appointmentDetails.reasonsForVisit) {
          const parsed = extractReasonsAndNotes(appointmentDetails.reasonsForVisit);
          setPetReasons(petToSelect.id, parsed.reasons);
          setPetNotes(petToSelect.id, parsed.notes);
        }
      }
    }

    openModal(MODALS.URGENT_VISIT_MODAL);
  };

  const handleContinueReschedule = () => {
    openModal(MODALS.RESCHEDULE_A_VISIT);
  };

  const handleBack = () => {
    openModal(MODALS.RESCHEDULE_A_VISIT);
  };

  return (
    <ConfirmUrgentVisitToggleContainer
      onConfirm={handleConfirmUrgentVisit}
      onCancel={handleContinueReschedule}
      cancelLabel="Continue Rescheduling"
      // eslint-disable-next-line max-len
      description="Switching to an Urgent Visit will cancel your current appointment. You'll have to start a new booking. What would you like to do?"
      showHeader
      onBack={handleBack}
      onClose={closeModal}
    />
  );
};

export default RescheduleUrgentVisitModal;
